// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { setQuarter as fn } from "../setQuarter.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const setQuarter = convertToFP(fn, 2);

// Fallback for modularized imports:
export default setQuarter;
